/// <reference lib="dom" />
import i18next from 'i18next';
import { registerSW } from 'virtual:pwa-register';
import { logger } from '@/shared/utils';
import { cleanupPWA, shouldEnablePWA } from './pwa-utils';

export async function registerPWA() {
  if (!shouldEnablePWA()) {
    await cleanupPWA();
    return;
  }

  const updateSW = registerSW({
    onNeedRefresh() {
      // Show a prompt to user about new content being available
      if (confirm(i18next.t('common:pwa.updatePrompt'))) {
        updateSW(true);
      }
    },
    onOfflineReady() {
      logger.info('App ready to work offline');
    },
    onRegistered(r) {
      logger.info('Service worker registered');

      // Set up periodic SW updates
      if (r) {
        setInterval(
          () => {
            r.update();
          },
          60 * 60 * 1000,
        ); // Check every hour
      }
    },
    onRegisterError(error) {
      logger.error('SW registration error', error);
    },
  });
}
